import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import InputSimples from '../../components/Inputs/Simples';
import Button from '../../components/Button/Simples';
import AlertGeral from '../../components/Alert/Geral';
import { requestPasswordRecovery } from '../../actions';
import errorHandling from '../../actions/errorHandling';

import { ReactComponent as Logo } from '../../assets/juliafloresrj-logo.svg';

class RecuperarSenha extends Component {

	state = {
		email: "",
		loading: false,
		sent: false,
		alert: null
	}

	onChangeInput = (field, ev) => this.setState({ [field]: ev.target.value });

	handleSubmit = () => {
		const { email, loading, sent } = this.state;
		if(loading || sent) return;

		if(!email || email.trim() === ""){
			this.setState({ alert: { status: false, msg: "Por favor, informe seu e-mail." } });
			return;
		}

		this.setState({ loading: true, alert: null });
		requestPasswordRecovery(email.trim())
			.then(() => this.setState({ sent: true, loading: false }))
			.catch((error) => {
				const handled = errorHandling(error);
				this.setState({
					loading: false,
					alert: { status: false, msg: handled.message }
				});
			});
	}

	render(){
		const { email, loading, sent, alert } = this.state;

		return (
			<div className="Login">
				<div className="login-content">
					<div className="logo">
						<Logo />
					</div>
					<div className="data-container">
						<h2 className="auth-title">Recuperar senha</h2>

						{ alert ? (<AlertGeral aviso={alert} time={5000} />) : null }

						{ sent ? (
							<>
								<p className="auth-subtitle">
									Enviamos um link de redefinição para <strong>{email}</strong>.
									Verifique sua caixa de entrada e spam.
								</p>
								<div className="auth-actions">
									<Link to="/login" className="auth-back-link">Voltar ao login</Link>
								</div>
							</>
						) : (
							<>
								<p className="auth-subtitle">
									Informe o e-mail da sua conta. Enviaremos um link para redefinir sua senha.
								</p>
								<InputSimples
									label="E-mail"
									value={email}
									type="email"
									onChange={(ev) => this.onChangeInput("email", ev)}
								/>
								<div className="auth-actions">
									<Link to="/login" className="auth-back-link">Voltar ao login</Link>
									<Button
										type="primary"
										label={loading ? "Enviando..." : "Enviar link"}
										onClick={() => this.handleSubmit()}
									/>
								</div>
							</>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default RecuperarSenha;
